import { GuideDefinition, SurveyDefinition } from './engagement.models';

export const PAYMENT_SUCCESS_EVENT = 'payment_success';

export const GUIDES: GuideDefinition[] = [
    {
        id: 'public-make-a-payment',
        version: 2,
        portal: 'public',
        title: 'Paying online',
        description: 'A quick look at where to start, your cart and help.',
        autoStartPath: /^\/$/,
        startUrl: '/',
        steps: [
            {
                target: '[data-guide="home-services"]',
                title: 'Start here',
                body: 'Choose what you want to pay. '
                    + 'Then enter your details to look up what you owe.',
                placement: 'top'
            },
            {
                target: '[data-guide="cart-button"]',
                title: 'Your cart',
                body: 'Items you add wait here. Review them, then check out.',
                placement: 'bottom',
                optional: true
            },
            {
                target: '[data-guide="help-button"]',
                title: 'Need a hand?',
                body: 'Help articles are one tap away, and you can replay this tour there.',
                placement: 'bottom',
                optional: true
            }
        ]
    },
    {
        id: 'admin-portal-tour',
        version: 2,
        portal: 'admin',
        title: 'Admin portal tour',
        description: 'A quick look at the main areas of the admin portal.',
        autoStartPath: /^\/dashboard$/,
        startUrl: '/dashboard',
        steps: [
            {
                title: 'Welcome to the admin portal',
                body: 'A 30-second look at where to find payments, schedules and users.'
            },
            {
                target: '[data-guide="admin-nav"]',
                title: 'Navigation',
                body: 'Every area of the portal is one click from here.',
                placement: 'bottom'
            },
            {
                target: '[data-guide="admin-payments"]',
                title: 'Payments',
                body: 'Search payments, open receipts and follow up on errors.',
                placement: 'bottom',
                optional: true
            },
            {
                target: '[data-guide="admin-schedules"]',
                title: 'Schedules',
                body: 'See recurring payments and when they ran.',
                placement: 'bottom',
                optional: true
            },
            {
                target: '[data-guide="admin-users"]',
                title: 'Users',
                body: 'Find users and confirm pending accounts.',
                placement: 'bottom',
                optional: true
            },
            {
                target: '[data-guide="admin-errored-payments"]',
                title: 'Needs attention',
                body: 'Payments that errored appear here so none are missed.',
                placement: 'right',
                optional: true
            }
        ]
    }
];

export const SURVEYS: SurveyDefinition[] = [
    {
        id: 'public-payment-nps',
        version: 1,
        portal: 'public',
        scale: 'nps10',
        question: 'How likely are you to recommend paying online to a friend or colleague?',
        followUps: {
            low: 'Sorry to hear that. What went wrong?',
            mid: 'Thanks. What could we do better?',
            high: 'Great to hear. What did we get right?'
        },
        lowLabel: 'Not likely',
        highLabel: 'Very likely',
        trigger: { type: 'event', name: 'payment_success' },
        delayMs: 2500,
        cooldownDays: 30,
        maxDismissals: 2
    },
    {
        id: 'admin-csat',
        version: 1,
        portal: 'admin',
        scale: 'csat5',
        question: 'How satisfied are you with the admin portal?',
        followUps: {
            low: 'Sorry about that. What is getting in your way?',
            mid: 'Thanks. What would make it better?',
            high: 'Glad to hear it. What works well for you?'
        },
        lowLabel: 'Very unsatisfied',
        highLabel: 'Very satisfied',
        trigger: { type: 'pageViews', count: 6 },
        delayMs: 1500,
        cooldownDays: 14,
        maxDismissals: 2
    }
];
